import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription, Observable } from "rxjs";
import { SkillTag } from "src/app/data/schema/Courses/SkillTag";
import { PatchUseInterestsTO } from "src/app/data/schema/User/PatchUserInterestsTO";
import { PatchUserSkillsDTO } from "src/app/data/schema/User/PatchUserSkillsDTO";
import { UsuarioTO } from "src/app/data/schema/User/UsuarioTO";
import { ProfileService } from "../../services/profile.service";

@Component({
    selector: "app-profile-skills",
    templateUrl: "./profile-skills.component.html",
    styleUrls: ["./profile-skills.component.scss"]
})
export class ProfileSkillsComponent implements OnInit, OnDestroy {
    private userSubscription: Subscription;
    private categoriesSubscription: Subscription;
    private user: UsuarioTO;

    public loading$: Observable<boolean>;
    public editMode: boolean;
    public tags: SkillTag[] = new Array<SkillTag>();

    constructor(private profileService: ProfileService) {
        this.editMode = false;

        this.loading$ = this.profileService.getLoadingAsync();

        this.categoriesSubscription = this.profileService.getSkillsAsync().subscribe((categories) => {
            if (categories) {
                categories.forEach((element) => this.tags.push(new SkillTag(element)));
                this.selectCourseTags();
            }
        });

        this.userSubscription = this.profileService.getUserAsync().subscribe((user) => {
            if (user) {
                this.user = user;
                this.selectCourseTags();
            }
        });
    }

    ngOnInit(): void {
        this.profileService.getLoggedUser();
        this.profileService.fetchSkills();
    }

    ngOnDestroy(): void {
        this.userSubscription.unsubscribe();
        this.categoriesSubscription.unsubscribe();
        this.profileService.clear();
    }

    toggleEdition(): void {
        if (this.editMode) {
            this.save();
        }

        this.editMode = !this.editMode;
    }

    private save(): void {
        let mainTags = new Array<string>();

        this.tags
            .filter((tag) => tag.selected)
            .forEach((element) => {
                mainTags.push(element.name);
            });

        const patch: PatchUserSkillsDTO = {
            skills: mainTags
        };

        this.profileService.updateUserSkills(patch);
    }

    private selectCourseTags = (): void => {
        if (!this.user || !this.tags) return;

        const allTags = [...this.user.skills];

        allTags.forEach((mainTag) => {
            let tagIndex = this.tags.findIndex((t) => t.name === mainTag);

            if (tagIndex >= 0) {
                this.tags[tagIndex].selected = true;
            }
        });
    };

    public selectMainTag(id: string): void {
        if (!this.editMode) return;

        var selectedTag = this.tags.filter((tag) => tag.name === id)[0];
        selectedTag.selected = !selectedTag.selected;
    }

    public getSelectedTags(): SkillTag[] {
        return this.tags.filter((tag) => tag.selected);
    }
}
